import * as React from "react"

const TextClassContext = React.createContext<string | undefined>(undefined)

export { TextClassContext }
